import { Component, OnInit } from '@angular/core';
import { LibraryService } from 'src/app/services/Library/library.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import * as moment  from 'moment';

@Component({
  selector: 'app-book-status',
  templateUrl: './book-status.component.html',
  styleUrls: ['./book-status.component.css']
})
export class BookStatusComponent implements OnInit {

  Submitted:boolean=false;
  BookAccList:any;
  BookStatus:any;
  ItemType:any;

  constructor(private  libraryservice: LibraryService,private lookupservice: LookupService, public globalHelper: GlobalHelper, 
    private spinnerService: Ng4LoadingSpinnerService) { }

    BookStatusModel = {
      ItemTypeID: 0,
      BookSerialNo: '',

  };

  Clear  () {
      this.BookStatusModel.ItemTypeID = 0;
      this.BookStatusModel.BookSerialNo = '';
      this.Submitted = false;
  }

 
  SaveBookStatus  () {
     this.spinnerService.show();
      this.libraryservice.SaveBookStatus(JSON.stringify(this.BookAccList)).subscribe( (response:any)=> {
        this.spinnerService.hide();
          this.globalHelper.CheckActionStatus(response);
          
      });
  };
   CheckValidation() {
      return this.BookStatusModel.ItemTypeID == 0;
  }
 

  GetALLBookAcc  () {
      this.Submitted = true;
      if (!this.CheckValidation()) {
        this.spinnerService.show();
          this.libraryservice.GetALLBookAcc(JSON.stringify(this.BookStatusModel)).subscribe( (response:any)=> {
            this.spinnerService.hide();
              this.BookAccList = response.BookAccList;
            
            //   this.globalHelper.CheckActionStatus(response);
          });
      }
  };



  

  GetAllBookStatus  () {
    this.spinnerService.show();
      this.lookupservice.GetLookupsList('BookStatus', '').subscribe( (data:any)=> {
          this.BookStatus = data.LookupItems;
         this.spinnerService.hide();
      });
  };
  GetItemType  () {
      this.lookupservice.GetLookupsList('ItemType', '').subscribe( (data:any)=> {
          this.ItemType = data.LookupItems;
      });
  };
  XLSDownload  () {
     this.spinnerService.show();
      if (this.BookAccList != null) {
          this.JSONToCsvConverterList(this.BookAccList, 'BookStatus_List', true);
      }

     this.spinnerService.hide();
  }

   JSONToCsvConverterList(JSONData, ReportTitle, ShowLabel) {
      var arrayData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;
      var CSV = '';
      if (ShowLabel) {
          var row = "";
          row += 'Sr. No.' + ',';
          row += 'Book Status' + ',';
          row += 'Remarks' + ',';
          row += 'Library Type' + ',';
          row += 'Acc No' + ',';
          row += 'Title' + ',';
          row += 'Author' + ',';
          row += 'Edition' + ',';
          row += 'Patrons' + ',';
          row += 'Name' + ',';
          row += 'Library Card No.' + ',';
          row = row.slice(0, -1);
          CSV += row + '\r\n';
      }
      for (var i = 0; i < arrayData.length; i++) {
          var sno = i + 1;
          var row = "";
          row += '"' + sno + '",';
          row += '"' + arrayData[i].BookStatus + '",';
          if (arrayData[i].Remarks != null) {
              row += '"' + arrayData[i].Remarks + '",';
          }
          else {
              row += '"' + '' + '",';
          }
          row += '"' + arrayData[i].LibraryType + '",';
          row += '"' + arrayData[i].BookSerialNo + '",';
          if (arrayData[i].BookTitle != null) {
              row += '"' + arrayData[i].BookTitle + '",';
          }
          else {
              row += '"' + '' + '",';
          }

          if (arrayData[i].AuthorName != null) {
              row += '"' + arrayData[i].AuthorName + '",';
          }
          else {
              row += '"' + '' + '",';
          }

          if (arrayData[i].BookEddition != null) {
              row += '"' + arrayData[i].BookEddition + '",';
          }
          else {
              row += '"' + '' + '",';
          }

          if (arrayData[i].PersonType != null) {
              row += '"' + arrayData[i].PersonType + '",';
          }
          else {
              row += '"' + '' + '",';
          }

          if (arrayData[i].FirstName != null) {
              row += '"' + arrayData[i].FirstName + '",';
          }
          else {
              row += '"' + '' + '",';
          }

          if (arrayData[i].LibCardNo != null) {
              row += '"' + arrayData[i].LibCardNo + '",';
          }
          else {
              row += '"' + '' + '",';
          }

          row.slice(0, row.length - 1);
          CSV += row + '\r\n';
      }
      if (CSV == '') {
          alert('Invalid Data');
          return;
      }
      var FileName = ReportTitle + '_' +  moment(new Date()).format("DD-MMM-YYYY");
      var csvData = new Blob([CSV], { type: 'text/csv;charset=utf-8;' });
      var csvURL = window.URL.createObjectURL(csvData);
      var tempLink = document.createElement('a');
      tempLink.href = csvURL;
      tempLink.setAttribute('download', FileName + '.csv');
      tempLink.click();
  }

  ngOnInit() {
    this.GetItemType();
    this.GetAllBookStatus();
  }

}
